<template>
  <v-content>
    <v-container fluid fill-height class="pl-0 pr-0 pt-0">
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <v-form @submit.prevent="onLogin">
            <v-card class="elevation-0 transparent px-8">
              <v-card-text class>
                <v-text-field
                  v-model.trim="senha1"
                  label="Senha Atual"
                  prepend-icon="lock"
                  title="Senha Atual"
                  :type="passwordVisibility ? 'text' : 'password'"
                  :append-icon="
                    passwordVisibility ? 'visibility_off' : 'visibility'
                  "
                  @click:append="
                    () => (passwordVisibility = !passwordVisibility)
                  "
                  class="pt-8"
                  color="var(--vs-azul-secundaria)"
                ></v-text-field>
                <v-text-field
                  v-model.trim="senha2"
                  label="Nova Senha"
                  prepend-icon="lock"
                  title="Nova Senha"
                  :type="passwordVisibility ? 'text' : 'password'"
                  :append-icon="
                    passwordVisibility ? 'visibility_off' : 'visibility'
                  "
                  color="var(--vs-azul-secundaria)"
                  @click:append="
                    () => (passwordVisibility = !passwordVisibility)
                  "
                  class="pt-8"
                ></v-text-field>
                <v-text-field
                  v-model.trim="senha3"
                  label="Confirme a Nova Senha"
                  prepend-icon="lock"
                  title="Confirme a Nova Senha"
                  :type="passwordVisibility ? 'text' : 'password'"
                  :append-icon="
                    passwordVisibility ? 'visibility_off' : 'visibility'
                  "
                  @click:append="
                    () => (passwordVisibility = !passwordVisibility)
                  "
                  class="pt-8"
                  color="var(--vs-azul-secundaria)"
                ></v-text-field>
              </v-card-text>
              <v-card-actions
                class="justify-center pt-6"
                style="padding-bottom:90px"
              >
                <vs-button
                  type="submit"
                  style="min-width: 90px"
                  color="warning"
                  :loading="loading"
                >
                  <i
                    class="las la-user-circle mr-3"
                    style="font-size: 20px !important"
                  ></i>
                  <template>Trocar Senha</template>
                </vs-button>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { version } from "./../../package.json";

export default {
  data() {
    return {
      senha1: "",
      senha2: "",
      senha3: "",
      passwordVisibility: false,
    };
  },
  computed: {
    ...mapState({
      showError: (state) =>
        state.core.error !== null && state.core.error !== "",
      user: (state) => state.cliente.user,
      loading: (state) => state.core.loading,
    }),
    ...mapGetters({
      empresa: "anuncio/empresa",
      cliente: "cliente/user",
      usuarioLogado: "cliente/usuarioLogado",
    }),
    version() {
      return version;
    },
  },
  methods: {
    onLogin() {
      this.$store.dispatch("cliente/trocarsenha", {
        busIntCod: this.usuarioLogado.busIntCod,
        senha1: this.senha1,
        senha2: this.senha2,
        senha3: this.senha3,
      });
    },
    novaConta() {
      this.$router.push({ name: "registro" });
    },
    onDismissed() {
      this.$store.dispatch("core/clearError");
    },
  },
};
</script>
